import api from '../api'

const baseUrl = '/BizSchool/api/Admin'

const dadbanStudentProvider = {
  getAllStudents(params = {}) {
    return api.post(`${baseUrl}/AdminStudentTable`, {
      params,
    })
  },

  getStudent(id) {
    return api.get(`${baseUrl}/GetAdminStudent/${id}`)
  },

  addStudent(params) {
    return api.post(`${baseUrl}/AdminStudent`, params)
  },

  updateStudent(params = {}) {
    return api.put(`${baseUrl}/AdminStudent`, params)
  },

  deleteStudent(params) {
    return api.delete(`${baseUrl}/AdminStudent/${params}`)
  },
}

export default dadbanStudentProvider
